import { Outlet } from "react-router-dom";
import Header from "@/components/Header";
import { ImpersonationBanner } from "@/components/ImpersonationBanner";
import { DevolutionNoticeModal } from "@/components/DevolutionNoticeModal";
import "@/hooks/theme";
// import { Toaster } from "@/components/ui/sonner";
import { createPortal } from "react-dom";
import { useMiddleware } from "@/hooks/auth";
import Navbar from "./components/Navbar";
import { ContextProviderPainel, useContextData } from "./components/Context";
import { Toaster } from "./components/ui/toaster";

export function AppContainer() {
  return (
    <div className="min-h-svh w-screen h-auto bg-zinc-100 dark:bg-zinc-950 text-black dark:text-zinc-100">
      <Outlet />
      {createPortal(
        //@ts-ignore
        <Toaster />,
        document.body
      )}
    </div>
  );
}

function AppContent() {
  const { isNavbarHidden } = useContextData();

  return (
    <div className="flex flex-col w-full h-full">
      <div className="flex h-svh w-screen overflow-auto">
        {!isNavbarHidden && <Navbar />}
        <div className="flex-1 h-full w-full overflow-y-auto dark:bg-[#202020]">
          <Header />
          <ImpersonationBanner />
          <DevolutionNoticeModal />
          <div className="flex-1 px-4 flex flex-col">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}

export function App() {
  if (useMiddleware()) return;

  return (
    <ContextProviderPainel>
      <AppContent />
    </ContextProviderPainel>
  );
}
